var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup__block"},[_vm._m(0),_c('div',{staticClass:"popup__content popup__content--login"},[_c('auth-form'),_c('registration-form')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup__tab",attrs:{"data-tabs":"popup__content--login"}},[_c('div',{staticClass:"popup__tab-item active"},[_vm._v("Авторизация")]),_c('div',{staticClass:"popup__tab-item"},[_vm._v("Регистрация")])])
}]

export { render, staticRenderFns }